import React from "react";
import { useParams } from "react-router-dom";
import CatalogListing from "../components/CatalogListing";
import { TOOLS_CATEGORIES } from "../constants/catalog";

export default function ToolsCategory() {
    const { slug } = useParams();
    const category = TOOLS_CATEGORIES.find((c) => c.slug === slug)
        || { slug, name: "Category", desc: "" };
    return (
        <div data-testid={`tools-category-page-${slug}`}>
            <CatalogListing topCategory="tools" topLabel="Tools & Accessories" topPath="/tools" category={category} />
        </div>
    );
}
